module.exports = __webpack_public_path__ + "media/images/athletes/2830-564833679a2d2d2289c00262874d793c.png";